var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28437 4.71937L4.19438 1.80937L7.10437 4.71937C7.39687 5.01187 7.86937 5.01187 8.16187 4.71937C8.45438 4.42687 8.45438 3.95437 8.16187 3.66187L4.71937 0.219375C4.42687 -0.073125 3.95437 -0.073125 3.66187 0.219375L0.219375 3.66187C-0.073125 3.95437 -0.073125 4.42687 0.219375 4.71937C0.511875 5.00437 0.991875 5.01187 1.28437 4.71937Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.c997b81a7bd6460b0e5ac8bcf8194254.svg";
export { ForwardRef as ReactComponent };